
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarouselTileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tile"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TileFieldsScreen"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"portraitImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"circularImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentItem"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentItemLightFieldsScreen"},"directives":[]}]}}]}}],"loc":{"start":0,"end":260}};
    doc.loc.source = {"body":"#import \"./content-item-light-fields-screen.gql\"\n#import \"./tile-fields-screen.gql\"\n\nfragment CarouselTileFields on Tile {\n  ...TileFieldsScreen\n  displayMode\n  heroImage\n  portraitImage\n  circularImage\n  contentItem {\n    ...ContentItemLightFieldsScreen\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./content-item-light-fields-screen.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./tile-fields-screen.gql").definitions));


      module.exports = doc;
    
